import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';

import { ItemLanguages, LanguagesTalent } from '@bloomays-lib/types.shared';
import { capitalize } from '@bloomays-lib/utils.shared';

import TalentSectionContainer from './TalentSectionContainer';
import { ItemTalentLevelProps } from '../atoms/ItemTalentLevel';
import ItemTalentLevelList from '../molecules/ItemTalentLevelList';

export type TalentLanguagesSectionProps = {
  languages: ItemLanguages[];
  addActionFn?: () => void;
};

const TalentLanguagesSection = ({ addActionFn, languages }: TalentLanguagesSectionProps) => {
  const { t } = useTranslation(['talentSheet']);

  const prepareLang = (languages?: LanguagesTalent[]): ItemTalentLevelProps[] => {
    const items: ItemTalentLevelProps[] = [];
    if (!languages) return [];

    languages?.forEach((lang) => {
      const capitalized: string = capitalize(t(lang.label, { ns: 'languages' })) || t(lang.label, { ns: 'languages' });

      items.push({
        skill: { label: capitalized, id: lang.id as string },
        level: lang?.level,
      });
    });
    return items;
  };

  return (
    <TalentSectionContainer
      title={t('lang')}
      emptyText={t('noLang')}
      addActionFn={addActionFn}
      addActionText={t('addLangs', { ns: 'talentSheet' })}
    >
      {languages && languages?.[0]?.label !== '' && languages.length > 0 && (
        <StyledContainerXP>
          <ItemTalentLevelList items={prepareLang(languages) || []} />
        </StyledContainerXP>
      )}
    </TalentSectionContainer>
  );
};

export { TalentLanguagesSection };
export default TalentLanguagesSection;

const StyledContainerXP = styled('div')(
  () => `
  display: flex;
  flex-flow: row nowrap;
  gap: 24px;
  align-items: flex-start;
  `,
);
